import Dashboard from './src/dashboard-combined';
export default Dashboard;